// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oooJ","left":"styles_left__3UnvR"};